import { Program } from "./Program";
import { Store } from "./Store";

export interface LabelTemplate {
    id: number;
    active: boolean;
    name: string;
    template: string;
    type: LabelTemplateType;
    stores?: Store[];
    programs?: Program[];
    states?: string[];
}

export enum LabelTemplateType {
    bottleLabel,
    bottleLabelQrCode
}